module.exports = __webpack_public_path__ + "img/start-light.aa1f60fd.png";